import { Config } from '@src/core/Config';

export enum PoolKind {
  Imp = 0,
  Golem,
  Projectile,
  Pickup,
  Spawner,
  Fx,
  Gargoyle,
  Boss,
  COUNT,
}

/**
 * Capacity accounting per archetype. BitECS recycles entity ids for us, so the
 * "pool" is a hard cap that keeps every typed array index below maxEntities and
 * keeps the renderer's InstancedMesh counts fixed.
 */
export class Pools {
  private readonly live = new Int32Array(PoolKind.COUNT);
  private readonly cap = new Int32Array(PoolKind.COUNT);

  constructor() {
    this.cap[PoolKind.Imp] = Config.pools.imps;
    this.cap[PoolKind.Golem] = Config.pools.golems;
    this.cap[PoolKind.Projectile] = Config.pools.projectiles;
    this.cap[PoolKind.Pickup] = Config.pools.pickups;
    this.cap[PoolKind.Spawner] = Config.pools.spawners;
    this.cap[PoolKind.Fx] = Config.pools.fx;
    this.cap[PoolKind.Gargoyle] = Config.pools.gargoyles;
    this.cap[PoolKind.Boss] = Config.pools.bosses;
  }

  tryAcquire(kind: PoolKind): boolean {
    if (this.live[kind] >= this.cap[kind]) return false;
    this.live[kind]++;
    return true;
  }

  release(kind: PoolKind): void {
    if (this.live[kind] > 0) this.live[kind]--;
  }

  count(kind: PoolKind): number {
    return this.live[kind];
  }

  capacity(kind: PoolKind): number {
    return this.cap[kind];
  }

  reset(): void {
    this.live.fill(0);
  }
}
